import {
  Apollo_gql,
  GraphPayload,
  GraphQueryInput,
  GraphQueryPayload,
  createQuery,
  graphQlTake,
} from '@camelot/server';
import { Mission } from '@camelot/services';

import { missionViewProps } from './dto/mission';

export function GET_MISSIONS_QUERY(input: GraphQueryInput<Mission>): GraphPayload {
  return createQuery<Mission>('missions', { ...input, prefixType: 'Mission' });
}

export function GET_MISSION_VIEW(): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query MissionView {
          missionView {
            items {
              ${missionViewProps.get('id')}
              ${missionViewProps.get('title')}
              ${missionViewProps.get('type')}
              ${missionViewProps.get('contactFullName')}
              ${missionViewProps.get('contactId')}
              ${missionViewProps.get('departmentName')}
              ${missionViewProps.get('projectAddress')}
              ${missionViewProps.get('projectId')}
            }
          }
        }
      `,
    variables: {},
  };
}

export function GET_MISSIONS(where: string, props: string, order: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query Missions {
          missions(${order}, ${where}, ${graphQlTake()}) {
            items {
              ${props}
            }
          }
        }
      `,
    variables: {},
  };
}
